import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import * as cartOverlayView from './cartOverlayView';
import CartManager from './cartManager';
import { onArticleAddedToCart } from '../../../home24-shared/tracking/cart/cart';
import CartOverlayEvents from '../../tracking/cart/CartOverlayEvents';

export default Backbone.View.extend({
    initialize: function (options) {
        this.options = options;

        _.bindAll(this, 'onAddToCartInit', 'onOverlayClose');

        $.subscribe('addToCartInit.shopApp:cart', this.onAddToCartInit);
        $.subscribe('addToCartInit.PdpApp:cart', this.onAddToCartInit);
        $.subscribe('closed.shopApp:dialog', this.onOverlayClose);
        $.subscribe('closed.PdpApp:dialog', this.onOverlayClose);
    },

    trackingCartOverlay: null,

    onAddToCartInit: function (event, data) {
        // initialize cart overlay
        cartOverlayView.init();

        var cartManager = new CartManager();

        cartManager
            .setSku(data.sku)
            .setQuantity(data.quantity || 1)
            .onLoad()
            .onSuccess(_.bind(this.onAddToCartSuccess, this))
            .onError(_.bind(this.onAddToCartFailure, this));

        if (data.assemblyService) {
            cartManager.setAssemblyService(data.assemblyService.sku);
        }

        cartManager.run();
    },

    onAddToCartSuccess: function (data) {

        $.publish('addToCartSuccess.shopApp:cart', data.html);
        $.publish('addToCartSuccess.PdpApp:cart', data.html);
        cartOverlayView.updateCartItemsCount(data.cartItemsCount);

        // tracking
        if (typeof data.trackingData === 'object') {
            onArticleAddedToCart(data.trackingData, this.options.pageType);

            // should be destroyed after quick view overlay closed
            this.trackingCartOverlay = new CartOverlayEvents({
                el: $('.pdp-cart-success__content')
            });
        }
    },

    onAddToCartFailure: function (textStatus, errorThrown) {
        $.publish('addToCartError.shopApp:cart', errorThrown);
        $.publish('addToCartError.PdpApp:cart', errorThrown);
    },

    onOverlayClose: function () {
        if (this.trackingCartOverlay) {
            this.trackingCartOverlay.destroy();
            this.trackingCartOverlay = null;
        }
    },

    destroy: function () {
        $.unsubscribe('addToCartInit.shopApp:cart', this.onAddToCartInit);
        $.unsubscribe('addToCartInit.PdpApp:cart', this.onAddToCartInit);
        $.unsubscribe('closed.shopApp:dialog', this.onOverlayClose);
        $.unsubscribe('closed.PdpApp:dialog', this.onOverlayClose);
    }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/components/addToCart/addToCart.js
 **/